import type { IIntegrationFormData } from "src/integrations/forms/IIntegrationFormData";
import {
  integrationDataToIntegration,
  integrationToIntegrationData,
} from "src/integrations/forms/IIntegrationFormData";
import type IntegrationType from "src/integrations/objects/IntegrationType";
import type { IntegrationWisepops } from "src/integrations/objects/IntegrationWisepops";

export const INTEGRATION_WISEPOPS_API_KEY = "apiKey";

export interface IIntegrationFormDataWisepops extends IIntegrationFormData {
  [INTEGRATION_WISEPOPS_API_KEY]: string;
}

export function integrationDataToIntegrationWisepops(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<IntegrationWisepops> {
  const integration: Partial<IntegrationWisepops> = {
    ...integrationDataToIntegration(
      integrationType,
      integrationData,
      integrationUuid,
    ),
  };
  if (!integrationUuid) {
    integration.apiKey = integrationData[INTEGRATION_WISEPOPS_API_KEY];
  }
  return integration;
}

export function integrationToIntegrationDataWisepops(
  integrationType: IntegrationType,
  integration: IntegrationWisepops,
): Partial<IIntegrationFormDataWisepops> {
  return {
    ...integrationToIntegrationData(integrationType, integration),
    [INTEGRATION_WISEPOPS_API_KEY]: integration.apiKey,
  };
}
